'use client';

import React from 'react';

// import { Typography } from '@mui/material';
import Box from '@mui/material/Box';
import styled from 'styled-components';

import ContentBlockTypes from './ContentBlockTypes';

type ManualData = {
  data: CategoryData;
  slug: string;
  title: string;
};

type ContentBlock = {
  id: string;
  title: string;
  order: number;
  items: Record<string, string>[];
};

interface ProductPageContentBlockProps {
  data: ContentBlock;
  manuals?: Record<string, ManualData>;
}

const Heading = styled.h2`
  display: flex;
  //width: 45.625rem;
  padding: 0rem 0rem 1.25rem 0rem;
  align-items: center;
  gap: 0.625rem;

  color: var(--Black, #2a2a2a);
  font-family: 'Atlas Grotesk';
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;

  ${({ theme }) => theme.breakpoints.down('md')} {
    padding-bottom: 0;
  }
`;

export default function ProductPageContentBlock({
  data,
}: // manuals,
  ProductPageContentBlockProps) {
  if (!data) {
    return null;
  }

  return (
    <Box mt={6}>
      <Heading>{data.title}</Heading>

      {data?.items &&
        data.items.map(item => (
          <ContentBlockTypes key={item.slug} item={item} />
        ))}
    </Box>
  );
}
